<div id="not-found">
  <h1>{{ 'notFound.code' | translate }}</h1>
  <h2>{{ 'notFound.title' | translate }}</h2>
  <h4>{{ 'notFound.subtitle' | translate }}</h4>
  <a routerLink="/">
    <button>{{ 'notFound.button' | translate }}</button>
  </a>
</div>
